import { useDispatch } from 'react-redux'
import { useCallback } from 'react'
import {
  actionDropPromisedPayment,
  actionGetPromisedPayment,
  actionGetSettings,
  actionResetPromisedPayment,
  actionCreatePromisedPaymentRequest,
  actionGetTakenPromisedPayment,
} from 'modules/Finance/PromisedPayment/store/actions'

export const usePromisedPayment = () => {
  const dispatch = useDispatch()

  const getSettings = useCallback(() => dispatch(actionGetSettings()), [])

  const getPromisedPayment = useCallback((props) => dispatch(actionGetPromisedPayment(props)), [])

  const dropPromisedPayment = useCallback(() => dispatch(actionDropPromisedPayment()), [])

  const resetPromisedPayment = useCallback(() => dispatch(actionResetPromisedPayment()), [])

  const createPromisedPaymentRequest = useCallback(
    (props) =>
      new Promise((resolve, reject) =>
        dispatch(actionCreatePromisedPaymentRequest({ meta: { resolve, reject }, ...props })),
      ),
    [],
  )

  const getTakenPromisedPayment = useCallback(() => dispatch(actionGetTakenPromisedPayment()), [])

  return {
    getSettings,
    getPromisedPayment,
    dropPromisedPayment,
    resetPromisedPayment,
    createPromisedPaymentRequest,
    getTakenPromisedPayment,
  }
}
